// ©2024 Austin App House. All rights reserved.
import React from 'react';
import { white as customSelectStyle } from '../../../utils/customSelectStyle';
import CustomFieldValueInput from './CustomFieldValueInput';
import Notification from '../../notification';
import CustomSelect from "../CustomSelect";

const CustomFieldFiltersSection = ({
  customFields,
  selectedCustomFields,
  selectCustomField,
}) => {
  const onChange = (customFieldId, value) => {
    const newSelectedCustomFields = selectedCustomFields.map(customField => (
      customField.value !== customFieldId
        ? customField
        : {
          ...customField,
          customFieldValue: value,
        }
    ));
    selectCustomField(newSelectedCustomFields);
  };

  // eslint-disable-next-line consistent-return
  const onSelect = values => {
    if (values && values.length > 5) {
      return Notification('warning', { message: 'You can select a maximum of 5 custom fields' });
    }
    selectCustomField(values);
  };

  const unSelectCustomField = customFieldId => {
    const newSelectedCustomFields = selectedCustomFields.filter(customField => (
      customField.value !== customFieldId
    ));
    selectCustomField(newSelectedCustomFields);
  };

  return (
      <>
      <div className="field_row">
        <div className="field_name">
          <span>Custom Field(s)</span>
        </div>
        <div className="field_block">
          <CustomSelect
            isClearable
            isSearchable
            isMulti
            closeMenuOnSelect={false}
            options={customFields}
            value={[...selectedCustomFields]}
            styles={customSelectStyle}
            onChange={onSelect}
          />
        </div>
      </div>
      <div className="custom_fields_values">
        {
          selectedCustomFields.map(customField => (
            <CustomFieldValueInput
              key={customField.value}
              id={customField.value}
              value={customField.customFieldValue}
              name={customField.label}
              onChange={event => onChange(customField.value, event.target.value)}
              remove={() => unSelectCustomField(customField.value)}
            />
          ))
        }
      </div>
    </>
  );
};

export default CustomFieldFiltersSection;
